import React, { Component } from "react";
import MUIDataTable from "mui-datatables";
import {
  createMuiTheme,
  MuiThemeProvider,
} from "@material-ui/core/styles";

import axios from 'axios';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from "@material-ui/core/Button";
import { Container, Row, Col } from "shards-react";
import {
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  TextField,
} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from "@material-ui/core/Tooltip";
import DriveEtaIcon from '@material-ui/icons/DriveEta';	
import RefreshIcon from '@material-ui/icons/Refresh';	
import MailIcon from '@material-ui/icons/Mail';	
import Backdrop from '@material-ui/core/Backdrop';
import Typography from '@material-ui/core/Typography';

import api from '../common/api';
import ConfirmDialog from '../common/ConfirmDialog'
import  PublishIcon from "@material-ui/icons/Publish";

class DueDates extends React.Component {

   constructor() {
      super();

      this.state = {
        data: '',
        isLoaded: false,
        vehicles:[],
        vehicles_filtered:[],
        expiration_type:{
                      'vtv_due_date':1, 'fire_extinguisher_due_date': 0, 'cardoc_due_date': 0,
                      'service_last_date': 0, warranty_up_to_date: 0
                    },
        days:30,
        mailing_day: new Date().getDate(),
        dialog: {open: false, message: '', title:'', errors:{errors:{'work_order.tasks':[]}}},

      }

      this.onChangeDays = this.onChangeDays.bind(this)
      this.onMailingDayChanged = this.onMailingDayChanged.bind(this)
      this.handleFilterSubmit = this.handleFilterSubmit.bind(this)

    }

    async componentDidMount() {
      var days = this.state.days
      const {vtv_due_date, cardoc_due_date, fire_extinguisher_due_date, warranty_up_to_date, service_last_date} = this.state.expiration_type
      await this.getVehicles(days,vtv_due_date, cardoc_due_date, fire_extinguisher_due_date, warranty_up_to_date, service_last_date);
    }
   
   getVehicles(days,vtv_due_date,cardoc_due_date,fire_extinguisher_due_date,warranty_up_to_date,service_last_date){
     const token =localStorage.getItem('userToken')
     const mailing_day = this.state.mailing_day
     return axios
              .get(api.vehicles().expirations(days, vtv_due_date, cardoc_due_date,fire_extinguisher_due_date,warranty_up_to_date,service_last_date,mailing_day),{ headers: {"Authorization" : `Bearer ${token}`} })
              .then(res => {
                this.setState({isLoaded: true, vehicles: res.data})
              })
              .catch(err =>{
                this.setState({isLoaded: true, vehicles: [] })
              })
  }
  getMuiTheme = () =>
    createMuiTheme({
      overrides: {
        MuiTableCell: {
         root: {
           padding: '4px 12px 4px 12px',
           fontSize: '0.73rem'
          }
        }
      },
  });      

  handleDownload = () => {
      var formData = new FormData();
      const token = localStorage.getItem('userToken')
      if (this.state.vehicles_filtered.length > 0){
        this.state.vehicles_filtered.map((val,idx)=>{
          formData.set("vehicle_id["+idx+"]", val.id);
        })
      }
      var mailing_day = this.state.mailing_day
      return axios
        .post(api.vehicles().expirations_export(this.state.days, 1, 1, 1, 1,1,mailing_day),
        formData,
        {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
         )
        .then((response)=> {
            window.location.href = response.data
        })
        .catch(error => {
            alert('Falló la descarga')
      })

  }


  onChangeDays(event){
    if (event.target.name === 'days'){
      this.setState({days: event.target.value})
    } else {
      var expiration_type = {
          'vtv_due_date':0, 'fire_extinguisher_due_date': 0, 'cardoc_due_date': 0,
          'service_last_date': 0, warranty_up_to_date: 0
        }
      expiration_type[event.target.value] = 1
      this.setState({expiration_type})
    }
  }

  onMailingDayChanged(event){
    this.setState({mailing_day: event.target.value})

  }

  handleFilterSubmit = applyFilters => {
    this.setState({vehicles:[],isLoaded: false})
    const days = this.state.days
    const {vtv_due_date, cardoc_due_date, fire_extinguisher_due_date, warranty_up_to_date, service_last_date} = this.state.expiration_type
    this.getVehicles(days,vtv_due_date,cardoc_due_date,fire_extinguisher_due_date,warranty_up_to_date,service_last_date)    
  };

  handleFilterVehicles = (rowIds) => {
    var vehicles_filtered = []
    var vehicles = this.state.vehicles
    rowIds.data.map((val, idx)=> {
      vehicles_filtered.push(vehicles[val.dataIndex])
    })
    this.setState({vehicles_filtered: vehicles_filtered})
  }

  handleCloseBackdrop = () => {
    var backdrop = !this.state.backdrop
    this.setState({backdrop: backdrop})
  }

  handleSendExpirationMails = (rowIds) => {
    var vehicles_filtered = []
    rowIds.data.map((val, idx)=> {
      vehicles_filtered.push(this.state.vehicles_filtered[val.dataIndex])
    })
    this.setState({backdrop: true})
    let self = this
		var dialog = this.state.dialog
    var formData = new FormData();
    const token = localStorage.getItem('userToken')
    if (this.state.vehicles_filtered.length > 0){
      vehicles_filtered.map((val,idx)=>{
        formData.set("vehicle_id["+idx+"]", val.id);
      })
    }
    return axios
      .post(api.vehicles().send_expiration_mails(this.state.days, 1, 1, 1, 1,1),
      formData,
      {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
       )
      .then((response)=> {
        dialog.title = 'Estado de vehículos'
        dialog.open = true
        dialog.success = 1
        dialog.message = 'Se ha lanzado con éxito!'
        self.setState({dialog: dialog})
        self.handleCloseBackdrop()        
      })
      .catch(error => {
        dialog.title = 'Estado de vehículos'
        dialog.open = true
        dialog.success = 0
        dialog.message = 'Ha ocurrido un error!'
        dialog.errors = 'Falló el proceso de envío de campaña. Contacte a su administrador'		  		
        self.setState({dialog: dialog})
        self.handleCloseBackdrop()        
    })    
  }

  handleDialogClose = () => {
    window.location.href=`/vehicles/expirations`
  }

  handleDialogAccept = () =>{
    window.location.href=`/vehicles/expirations`
  }

  handleDialogCancel = () =>{
    window.location.href=`/vehicles/expirations`
  }

  dateRender(value){
    if (value){
      if (value <= 0){
        return (
          <div class="text-danger font-weight-bold">
              Vencido
          </div>
        )          

      }
      if (value <15){
        return (
          <div class="text-danger font-weight-bold">
              Vence en {value} días
          </div>
        )          
      } else if (value < 30){
        return (
          <div class="text-warning font-weight-bold">
              Vence en {value} días
          </div>
        )          
      }            
    }
    return null    
  }

  render(){
     var columns = [
     {
      name: "id",
      label: "Id",
      options: {
       filter: false,
       sort: true,
      }
     },
     {
      name: "plate",
      label: "Patente",
      options: {
       filter: false,
       filterType: "textField",
       sort: true,
      }
     },
     {
      name: "state",
      label: "Estado",
      options: {
       filter: true,
       filterType: "dropdown",
       sort: true,
      }
     },
     {
      name: "description",
      label: "Descripción",
      options: {
       filter: false,
       filterType: "textField",
       sort: true,
      }
     },
     {
      name: "contract.name",
      label: "Contrato",
      options: {
       filter: true,
       filterType: "dropdown",
      }
     },
     {
      name: "client",
      label: "Cliente",
      options: {
       filter: true,
       display: false,
       filterType: "dropdown",
      }
     },
     {
      name: "driver.firstname",
      label: "Nombre",
      options: {
       filter: false,
       filterType: "dropdown",
      }
     },
     {
      name: "driver.lastname",
      label: "Apellido",
      options: {
       filter: false,
       filterType: "dropdown",
      }
     },
     {
      name: "driver.email",
      label: "Email",
      options: {
       filter: false,
       display: false,
       filterType: "dropdown",
      }
     },
     {
      name: "driver.phone",
      label: "Telefono",
      options: {
       filter: false,
       display: false,
       filterType: "dropdown",
      }
     },
     {
      name: "vtv_due_date_days",
      label: "VTV",
      options: {
        filter: false,
        filterType: 'checkbox',
        display: Boolean(this.state.expiration_type.vtv_due_date),
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return this.dateRender(value)
        }
      }
    },
    {
      name: "cardoc_due_date_days",
      label: "Cedula Verde",
      options: {
        filter: false,
        filterType: 'checkbox',
        display: Boolean(this.state.expiration_type.cardoc_due_date),
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return this.dateRender(value)
        }
      }
    },
    {
      name: "fire_extinguisher_due_date_days",
      label: "Matafuegos",
      options: {
        filter: false,
        filterType: 'checkbox',
        display: Boolean(this.state.expiration_type.fire_extinguisher_due_date),
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return this.dateRender(value)
        }
      }
    },
    {
      name: "service_last_date_months",
      label: "Service",
      options: {
        filter: false,
        filterType: 'checkbox',
        display: Boolean(this.state.expiration_type.service_last_date),
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          value = parseInt(value)
          if (value >= 0){
              if (value < 1){
              return (
                <div class="text-danger font-weight-bold">
                    Vence este mes
                </div>
              )          
            } else if (value < 2){
              return (
                <div class="text-warning font-weight-bold">
                    Vence en 2 meses
                </div>
              )          
            }            
          }
          return ''    
        }
      }
    },
    {
      name: "warranty_up_to_date_days",
      label: "Garantía",
      options: {
        filter: false,
        filterType: 'checkbox',
        display: Boolean(this.state.expiration_type.warranty_up_to_date),
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return this.dateRender(value)
        }
      }
    },
    {
      name: "userOperator.name",
      label: "Operador",
      options: {
        filter: true,
        display: false,
        filterType: 'dropdown',
        sort: true,
      }
    },    
    {
      name: "send_expiration_mailing",
      label: "Enviar estado?",
      options: {
        filter: true,
        display: false,
        filterType: 'dropdown',
        sort: true,
      }
    },     
    {
      name: "mailing_day",
      label: "Día de envío",
      options: {
        filter: true,
        display: false,
        filterType: 'dropdown',
        sort: true,
      }
    },     
     {
      name: "work_orders.id",
      label: "OTs Abierta",
      options: {
       display: true,
       filter: true,
       filterType: 'dropdown',
       filterOptions: {
          names: ['Si', 'No'],
          logic(work_orders, filterVal) {
            var show = false
            if (filterVal[0] === 'Si'){
              if (work_orders > 0){
                show = true
              }
            } else {
              if (work_orders === 'No'){
                show = true
              }
            }
            return !show;
          },
        },       
       customBodyRender: (value, tableMeta, updateValue) => {
          var plate = tableMeta.rowData[1]
          if (value){
            return(
              <a href={"/work-orders?plate=" + plate} target="_blank">Ver OT</a>
            )
          } else {
            return (
              "No")
          }
        }
      }
     }
  ];

  const days = this.state.days 
  const mailing_day = this.state.mailing_day
  const expiration_type = (this.state.expiration_type) ? this.state.expiration_type : 'vtv_due_date' 
  var options = {
    print:false,
    responsive: 'stacked',
    rowsPerPage: 10,
    confirmFilters: true, 
    download: (this.state.vehicles_filtered.length > 0) ? true : false,
    onDownload: () => {
      this.handleDownload()
      return false
    },
    customFilterDialogFooter: (currentFilterList, applyNewFilters) => {
      return (
        <React.Fragment>
          <div style={{ marginTop: '40px' }}>
            <FormControl className="mr-2">
              <InputLabel>
                Días
              </InputLabel>
              <Select
                name="days"
                onChange={event => {
                  this.onChangeDays(event);
                }}
                value={days}
                style={{minWidth: 70, fontSize: '0.75rem'}}
              >
                  <MenuItem value="15" style={{fontSize: '0.75rem'}}>15</MenuItem>
                  <MenuItem value="30" style={{fontSize: '0.75rem'}}>30</MenuItem>
                  <MenuItem value="45" style={{fontSize: '0.75rem'}}>45</MenuItem>
                  <MenuItem value="60" style={{fontSize: '0.75rem'}}>60</MenuItem>
              </Select>
            </FormControl>

            <FormControl className="mr-2">
                <TextField
                  name="mailing_day"
                  label="Dia de vencimiento"
                  onChange={event => {
                    this.onMailingDayChanged(event);
                  }}
                  className="m-0 p-0 mr-2"
                  InputLabelProps={{
                    shrink: true
                  }}
                  inputProps={{style:{fontSize: '0.75rem'},
                              min:0,
                              max:31
                  }}
                  value={mailing_day}
                  type="number"
                  style={{minWidth: 70, fontSize: '0.75rem'}}
                />
            </FormControl>

            <FormControl>
              <InputLabel style={{fontSize: '0.75rem'}}>
                Tipo Vencimientos
              </InputLabel>
              <Select
                name="expiration_type"
                onChange={event => {
                  this.onChangeDays(event);
                }}
                style={{minWidth: 150, fontSize: '0.75rem'}}
              >
                  <MenuItem value="vtv_due_date" style={{fontSize: '0.75rem'}}>VTV</MenuItem>
                  <MenuItem value="cardoc_due_date" style={{fontSize: '0.75rem'}}>Documentación</MenuItem>
                  <MenuItem value="service_last_date" style={{fontSize: '0.75rem'}}>Service</MenuItem>
                  <MenuItem value="fire_extinguisher_due_date" style={{fontSize: '0.75rem'}}>Matafuegos</MenuItem>
                  <MenuItem value="warranty_up_to_date" style={{fontSize: '0.75rem'}}>Garantía</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div>
          <Button variant="contained" color="primary" className="mt-3" style={{fontSize: '0.75rem'}}  onClick={() => this.handleFilterSubmit(applyNewFilters)}>Aplicar filtros</Button>
        </div>
        </React.Fragment>
      );
    },

    // callback that gets executed when filters are confirmed
    onFilterConfirm: (filterList) => {
      console.log('onFilterConfirm');
    },

    onFilterDialogOpen: () => {
      console.log('filter dialog opened');
    },
    onFilterDialogClose: () => {
      console.log('filter dialog closed');
    },
    onFilterChange: (column, filterList, type) => {
      if (type === 'chip') {
        var newFilters = () => (filterList);
        this.handleFilterSubmit(newFilters);
      }
    },
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {
      return(
        <React.Fragment>
          <div className="ml-2">
          {
            (this.state.vehicles_filtered.length === 0 ) && 
            <Tooltip title={"Armar campaña"}>
              <IconButton onClick={()=> this.handleFilterVehicles(selectedRows)}>
                <DriveEtaIcon onClick={()=> this.handleFilterVehicles(selectedRows)}/>
              </IconButton>
            </Tooltip>
          }
          {
            (this.state.vehicles_filtered.length > 0 ) && 
            <Tooltip title={"Enviar campaña"}>
              <IconButton>
                <MailIcon onClick={()=> this.handleSendExpirationMails(selectedRows)}/>
              </IconButton>
            </Tooltip>
            }
          </div>
        </React.Fragment>
      )
    },
    customToolbar: () => {
      return (
        <React.Fragment>
          <Tooltip title={"Reiniciar"}>
            <IconButton onClick={()=> this.setState({vehicles_filtered:[]})}>
              <RefreshIcon onClick={()=> this.setState({vehicles_filtered:[]})}/>
            </IconButton>
          </Tooltip>
          <Tooltip title={"Importar"}>
            <IconButton onClick={(e)=>{window.location.href="0/1/0/import"}}>
              <PublishIcon />
            </IconButton>
          </Tooltip>
      </React.Fragment>
      );
    },
    textLabels: {
          toolbar: {
            search: "Buscar",
            viewColumns: "Ver columnas",
            filterTable: "Filtros",   
            downloadCsv: "Exportar XLS",
          },
          body: {
              noMatch: this.state.isLoaded ?
                  'No hay resultados' :
                  <CircularProgress />,
          },
          selectedRows: {
            text: "fila(s) seleccionadas"
          },
          viewColumns: {
            title: "Ver columnas",
          },
          pagination: {
            next: "Siguiente",
            previous: "Anteior",
            rowsPerPage: "Cantidad por página:",
            displayRows: "de",      
          },
          filter: {
            all: "Todos",
            title: "Filtros",
            reset: "Limpiar"
          }
      }
  };

   var data = (this.state.vehicles_filtered.length > 0) ? this.state.vehicles_filtered : this.state.vehicles
   if (this.state.vehicles_filtered.length > 0){
    columns[3].options.filterList = []
    options.rowsSelected = []
   }
   return(
      <Container fluid className="main-content-container px-4">
          <Row>
            <Col className="p-2">
              <div>    
                <MuiThemeProvider theme={this.getMuiTheme()}>
                  <MUIDataTable
                    title="Vencimientos"
                    data={Object.values(data)}
                    columns={columns}
                    options={options}
                    
                  />
                  <div style={{textAlign: "right"}}>
                    <Button variant="contained" className="mt-3 ml-1 mr-1" color="secondary" href={"/contracts"}>
                      Volver
                    </Button>
                  </div>
                </MuiThemeProvider>
              </div>
            </Col>
          </Row>
          <ConfirmDialog 
								confirm_dialog={this.state.dialog.open} 
								title={this.state.dialog.title}
								message={this.state.dialog.message}
								onClose={this.handleDialogClose} 
								onAccept={this.handleDialogAccept}
								onCancel={this.handleDialogCancel}
								errors={this.state.dialog.errors}
          />
          <Backdrop open={this.state.backdrop} onClick={this.handleCloseBackdrop} style={{zIndex: 10000, color: '#3f51b5'}}>
              <Typography className="ml-2" variant="h5" color="primary">Enviando...</Typography>
          </Backdrop>

       </Container>
    );
  }

}

export default DueDates;   